export const data = {
	heading: 'Разработка первых сервисов',
	content: [
		'С самого начала мы строили доверительные и партнёрские отношения с клиентами. Благодаря этому мы ежегодно увеличивали клиентскую базу, что в итоге привело к необходимости автоматизации части процессов внутри компании. Так, в 2017 году мы приступили к разработке первых версий методики оценки недвижимости, конструктора договоров и приложения для операторов.',
		'Мы понимали, что без развития технологий невозможно устойчивое и уверенное развитие компании.',
	],
}
